if (!customElements.get('product-upsell')) {
  customElements.define('product-upsell',
    class ProductUpsell extends HTMLElement {
      constructor() {
        super();

        this.productId = this.getAttribute('data-product-id');
        this.addBtn = this.querySelector('[data-upsell-add]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      }

      connectedCallback() {
        if (!this.addBtn) return;
        this.addBtn.addEventListener('click', this.addUpsellItem.bind(this));
      }

      addUpsellItem() {
        if (!this.productId || this.addBtn.getAttribute('aria-disabled') === 'true') return;

        this.addBtn.setAttribute('aria-disabled', 'true');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        const data = {
          items: [{
            quantity: 1,
            id: this.productId
          }],
        }

        if (this.cart) {
          data.sections = this.cart.getSectionsToRender().map((section) => section.id);
          data.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            console.error('Error:', response.description);
            this.addBtn.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-upsell'});
          this.error = false;
          this.cart.renderContents(response);
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.addBtn.removeAttribute('aria-disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        })
      }
    }
  )
}